// This file is auto-generated by @hey-api/openapi-ts
export const AGENT_METHODS = {
    initialize: "initialize",
    authenticate: "authenticate",
    providers_list: "providers/list",
    providers_set: "providers/set",
    providers_disable: "providers/disable",
    session_new: "session/new",
    session_load: "session/load",
    session_set_mode: "session/set_mode",
    session_set_config_option: "session/set_config_option",
    session_prompt: "session/prompt",
    session_cancel: "session/cancel",
    mcp_message: "mcp/message",
    session_list: "session/list",
    session_delete: "session/delete",
    session_fork: "session/fork",
    session_resume: "session/resume",
    session_close: "session/close",
    logout: "logout",
    nes_start: "nes/start",
    nes_suggest: "nes/suggest",
    nes_accept: "nes/accept",
    nes_reject: "nes/reject",
    nes_close: "nes/close",
    document_did_open: "document/didOpen",
    document_did_change: "document/didChange",
    document_did_close: "document/didClose",
    document_did_save: "document/didSave",
    document_did_focus: "document/didFocus",
};
export const CLIENT_METHODS = {
    session_request_permission: "session/request_permission",
    session_update: "session/update",
    fs_write_text_file: "fs/write_text_file",
    fs_read_text_file: "fs/read_text_file",
    terminal_create: "terminal/create",
    terminal_output: "terminal/output",
    terminal_release: "terminal/release",
    terminal_wait_for_exit: "terminal/wait_for_exit",
    terminal_kill: "terminal/kill",
    mcp_connect: "mcp/connect",
    mcp_message: "mcp/message",
    mcp_disconnect: "mcp/disconnect",
    elicitation_create: "elicitation/create",
    elicitation_complete: "elicitation/complete",
};
export const PROTOCOL_METHODS = {
    cancel_request: "$/cancel_request",
};
export const PROTOCOL_VERSION = 1;
//# sourceMappingURL=index.js.map